import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { checkSession, logout as apiLogout } from "./authApi";

// Contexte de session client partagé par TOUT le site :
//  - Home (header "Bonjour ..." + formulaire passagers)
//  - pages /compte/* (dashboard, paramètres, carnet...)
const AuthContext = createContext({
  customer: null,
  loading: true,
  refresh: () => {},
  login: () => {},
  logout: () => {},
});

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { loggedIn, customer: c } = await checkSession();
      setCustomer(loggedIn ? c : null);
    } catch (e) {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const doLogin = useCallback(
    (c) => {
      setCustomer(c);
      setLoading(false);
    },
    []
  );

  const doLogout = useCallback(async () => {
    try {
      await apiLogout();
    } catch (e) {
      // même si l'appel échoue, on nettoie l'état local
    }
    setCustomer(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        customer,
        loading,
        refresh,
        login: doLogin,
        logout: doLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthProvider;